exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".price-box[data-v-1ea25d22] {\n  max-width: 400px;\n}\n", "", {"version":3,"sources":["/home/vsts/work/1/s/apps/client/landing/src/molecules/components/PlanCard.vue"],"names":[],"mappings":"AAOA;EACI,iBAAgB;CAAA","file":"PlanCard.vue?vue&type=style&index=0&id=1ea25d22&lang=scss&scoped=true&","sourcesContent":["@import \"../../../../common/styles/user-variables\";\n@import \"../../../../vendor/createx/styles/helpers\";\n@import \"~bootstrap/scss/functions\";\n@import \"~bootstrap/scss/variables\";\n@import \"~bootstrap/scss/mixins\";\n\n\n.price-box {\n    max-width: 400px;\n}\n"],"sourceRoot":""}]);

// exports
